unit SchoolListPage;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  BaseList,
  WEBLib.ExtCtrls,
  WEBLib.Actions,
  Data.DB,
  WEBLib.DB,
  XData.Web.JsonDataset,
  XData.Web.Dataset,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  WEBLib.Grids,
  WEBLib.DBCtrls,
  Vcl.Controls,
  WEBLib.Lists,
  WEBLib.WebCtrls;

type
  TSchoolsForm = class(TBaseListForm)
    MainDatasetId: TIntegerField;
    MainDatasetDateAdded: TDateTimeField;
    MainDatasetAddedBy: TIntegerField;
    MainDatasetLastUpdatedBy: TIntegerField;
    MainDatasetLastUpdated: TDateTimeField;
    MainDatasetLocationName: TStringField;
    MainDatasetAdd1: TStringField;
    MainDatasetAdd2: TStringField;
    MainDatasetAdd3: TStringField;
    MainDatasetTown: TStringField;
    MainDatasetRegion: TStringField;
    MainDatasetPostCode: TStringField;
    MainDatasetCountryCode: TStringField;
    MainDatasetExternalId: TStringField;
    MainDatasetTelephone: TStringField;
    MainDatasetEmail: TStringField;
    MainDatasetLocalAuthority: TStringField;
    MainDatasetAcademyId: TIntegerField;
    MainDatasetStatus: TStringField;
    MainDatasetSchoolKind: TStringField;
    AccountsDataSet: TXDataWebDataSet;
    AccountsDataSetId: TIntegerField;
    AccountsDataSetDateAdded: TDateTimeField;
    AccountsDataSetAddedBy: TIntegerField;
    AccountsDataSetLastUpdatedBy: TIntegerField;
    AccountsDataSetLastUpdated: TDateTimeField;
    AccountsDataSetLocationName: TStringField;
    AccountsDataSetAdd1: TStringField;
    AccountsDataSetAdd2: TStringField;
    AccountsDataSetAdd3: TStringField;
    AccountsDataSetTown: TStringField;
    AccountsDataSetRegion: TStringField;
    AccountsDataSetPostCode: TStringField;
    AccountsDataSetCountryCode: TStringField;
    AccountsDataSetExternalId: TStringField;
    AccountsDataSetTelephone: TStringField;
    AccountsDataSetEmail: TStringField;
    AccountsDataSetSchoolId: TIntegerField;
    tmrAccountsDataLoad: TTimer;
    MainDatasetPupilCount: TIntegerField;
    MainDatasetCostingId: TIntegerField;
    MainDatasetPONumber: TStringField;
    procedure WebFormShow(Sender: TObject);
    procedure AccountsDataSetAfterPost(DataSet: TDataSet);
    procedure tmrAccountsDataLoadTimer(Sender: TObject);
  private
    { Private declarations }
    FSchoolId: Integer;
    FBuildingQuery: Boolean;

    [async]
    procedure AccountEditLoad; async;

  protected
    [async]
    procedure EditRecord(const ARecordId: string); async; override;

    [async]
    procedure EditAccountRecord(const ARecordId: string); async;

    [async]
    procedure SendDeclineLetter(ARecordId: string); async;
    procedure DeclineMembership(const ARecordId: string);

    procedure AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement); override;
    procedure PrepareForm; override;

    procedure LoadData; override;
    procedure SearchData(const Value: string); override;

  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  SchoolsForm: TSchoolsForm;

implementation

{$R *.dfm}

uses
  SMX.Web.Layout.Utils,
  XData.Web.Client,
  MainDataModule,
  SchoolEditPage,
  SchoolAccountEditPage,
  Web.StringUtils;

{ TSchoolsForm }

procedure TSchoolsForm.AccountEditLoad;
var
  AForm: TSchoolAccountEditForm;

begin
  AForm := TSchoolAccountEditForm.Create(Self);
  try
    AForm.Popup := True;
    AForm.PopupOpacity := 1;
    AForm.IdField := FIdField;
    AForm.Caption := 'Standard Editor';

    Await(TSchoolAccountEditForm, AForm.Load());
    Await(AForm.InitForm);

    AForm.Dataset := AccountsDataSet;

    Await(TModalResult, AForm.Execute);

  finally
    AForm.Free;
    AForm := nil;

  end;

end;

procedure TSchoolsForm.AccountsDataSetAfterPost(DataSet: TDataSet);
begin
  AccountsDataSet.ApplyUpdates;

end;

procedure TSchoolsForm.AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement);

  procedure EditAccountsClick(Sender: TObject);
  begin
    EditAccountRecord(ARecordId);

  end;

  procedure DeclineClick(Sender: TObject);
  begin
    DeclineMembership(ARecordId);

  end;

var
  Span: THTMLSpan;

begin
  inherited;

  Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-solid fa-file-invoice fa-fw fa-lg', 'Accounts');
  Span.OnClick := @EditAccountsClick;

  Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-solid fa-file-invoice fa-fw fa-lg', 'Decline');
  Span.OnClick := @DeclineClick;

end;

procedure TSchoolsForm.EditRecord(const ARecordId: string);
var
  AForm: TSchoolEditForm;

begin
  //this isn't really Async until the next version of XData
  Await(MainData.OpenAcademyLookUp);

  if ARecordId = ''  then
    MainDataset.Append
  else
    MainDataset.Locate('Id', ARecordId.ToInteger, []);

  AForm := TSchoolEditForm.Create(Self);
  try
    AForm.Popup := True;
    AForm.PopupOpacity := 1;
    AForm.IdField := FIdField;

    Await(TSchoolEditForm, AForm.Load());
    Await(AForm.InitForm);

    AForm.Dataset := MainDataset;
    AForm.IsInsert := ARecordId = '';

    Await(TModalResult, AForm.Execute);

  finally
    AForm.Free;
    AForm := nil;

  end;

  StandardLoadData;

end;

procedure TSchoolsForm.EditAccountRecord(const ARecordId: string);
begin
  FSchoolId := ARecordId.ToInteger;

  AccountsDataSet.Close;
  AccountsDataSet.QueryString := '$filter= SchoolId eq ' + ARecordId;
  AccountsDataSet.Load;

  tmrAccountsDataLoad.Enabled := True;

end;

procedure TSchoolsForm.DeclineMembership(const ARecordId: string);
begin
  MessageDlg(
    'This will remove the school form this years membership, cancel and invoices or payments, and send a non-members email.' + sLineBreak +
    'Are you sure you wish to proceed?',
    mtConfirmation,
    [mbYes, mbNo],
    procedure(Res: TModalResult)
    begin
      if Res = mrYes then
      begin
        SendDeclineLetter(ARecordId);

      end;

    end
  );

end;

procedure TSchoolsForm.LoadData;
begin
  StandardLoadData;

end;

procedure TSchoolsForm.PrepareForm;
begin
  FIdField := 'Id';

  MainDataset.Connection := MainData.DataConnection;
  AccountsDataset.Connection := MainData.DataConnection;

end;

procedure TSchoolsForm.SearchData(const Value: string);
var
  sQuery: string;
  sValue: string;

begin
  if Trim(Value) = '' then
  begin
    // use default searching mechanism if no data entered
    inherited;

  end
  else
  begin
    // don't build if already building
    if FBuildingQuery then
      Exit;

    FBuildingQuery := True;

    // determine query sql
    sValue := EscapeSingleQuotesFirebird(UpperCase(Trim(Value)));
    if ContainsAlpha(Value) then
      sQuery :=
        'contains(upper(LocationName), ''' + Copy(sValue, 1, 255) + ''')' + ' or ' +
        'contains(upper(Add1), ''' + Copy(sValue, 1, 100) + ''')' + ' or ' +
        'contains(upper(PostCode), ''' + Copy(sValue, 1, 25) + ''')' + ' or ' +
        'upper(ExternalId) eq ''' + Copy(sValue, 1, 75) + ''''
    else
      sQuery :=
        'upper(ExternalId) eq ''' + Copy(sValue, 1, 75) + '''' + ' or ' +
        'Id eq ''' + sValue + ''''
      ;

    FGridPlugin.SetPreparedFilter(sQuery);

    FBuildingQuery := False;

  end;

end;

procedure TSchoolsForm.WebFormShow(Sender: TObject);
begin
  inherited;
  cbPageSizeChange(cbPageSize);
  AccountsDataSet.Load;

end;

procedure TSchoolsForm.tmrAccountsDataLoadTimer(Sender: TObject);
begin
  TTimer(Sender).Enabled := False;

  if AccountsDataSet.IsEmpty then
  begin
    AccountsDataSet.Edit;
    AccountsDataSet.FieldByName('SchoolId').AsInteger := FSchoolId;
    AccountsDataSet.FieldByName('Email').AsString := '';
    AccountsDataSet.FieldByName('LocationName').AsString := '';

  end;

  AccountEditLoad;

end;

procedure TSchoolsForm.SendDeclineLetter(ARecordId: string);
const
  SC_SendDeclineLetter = 'ISchoolService.SendDeclineLetter';

var
  oClientResponse: TXDataClientResponse;
  bSuccess: Boolean;

  slMessages: TStringList;

  iIdx: Integer;

  jsaResponseList: JS.TJSArray;
  jsoServerResponse: JS.TJSObject;

begin
  oClientResponse := Await(
    TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync(
      SC_SendDeclineLetter,
      [ ARecordId ]
    )
  );

  // generate list of errors to display to the user
  slMessages := TStringList.Create;
  slMessages.Delimiter := #13;
  slMessages.StrictDelimiter := True;
  slMessages.Add('');
  slMessages.Add('');

  jsaResponseList := JS.toArray(oClientResponse.ResultAsObject['ServerResponses']);

  bSuccess := True;
  for iIdx := 0 to jsaResponseList.Length - 1 do
  begin
    jsoServerResponse := JS.toObject(jsaResponseList[iIdx]);

    bSuccess := bSuccess and JS.toBoolean(jsoServerResponse['Success']);
    slMessages.Add(JS.toString(jsoServerResponse['Status']));

  end;

  if bSuccess then
    slMessages.Insert(0, 'SUCCESS')
  else
    slMessages.Insert(0, 'ERROR');

  ShowMessage(slMessages.DelimitedText);

  slMessages.Free;

end;



procedure TSchoolsForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  MainDatasetId := TIntegerField.Create(Self);
  MainDatasetDateAdded := TDateTimeField.Create(Self);
  MainDatasetAddedBy := TIntegerField.Create(Self);
  MainDatasetLastUpdatedBy := TIntegerField.Create(Self);
  MainDatasetLastUpdated := TDateTimeField.Create(Self);
  MainDatasetLocationName := TStringField.Create(Self);
  MainDatasetAdd1 := TStringField.Create(Self);
  MainDatasetAdd2 := TStringField.Create(Self);
  MainDatasetAdd3 := TStringField.Create(Self);
  MainDatasetTown := TStringField.Create(Self);
  MainDatasetRegion := TStringField.Create(Self);
  MainDatasetPostCode := TStringField.Create(Self);
  MainDatasetCountryCode := TStringField.Create(Self);
  MainDatasetExternalId := TStringField.Create(Self);
  MainDatasetTelephone := TStringField.Create(Self);
  MainDatasetEmail := TStringField.Create(Self);
  MainDatasetLocalAuthority := TStringField.Create(Self);
  MainDatasetAcademyId := TIntegerField.Create(Self);
  MainDatasetStatus := TStringField.Create(Self);
  MainDatasetSchoolKind := TStringField.Create(Self);
  MainDatasetPupilCount := TIntegerField.Create(Self);
  MainDatasetCostingId := TIntegerField.Create(Self);
  MainDatasetPONumber := TStringField.Create(Self);
  AccountsDataSet := TXDataWebDataSet.Create(Self);
  AccountsDataSetId := TIntegerField.Create(Self);
  AccountsDataSetDateAdded := TDateTimeField.Create(Self);
  AccountsDataSetAddedBy := TIntegerField.Create(Self);
  AccountsDataSetLastUpdatedBy := TIntegerField.Create(Self);
  AccountsDataSetLastUpdated := TDateTimeField.Create(Self);
  AccountsDataSetLocationName := TStringField.Create(Self);
  AccountsDataSetAdd1 := TStringField.Create(Self);
  AccountsDataSetAdd2 := TStringField.Create(Self);
  AccountsDataSetAdd3 := TStringField.Create(Self);
  AccountsDataSetTown := TStringField.Create(Self);
  AccountsDataSetRegion := TStringField.Create(Self);
  AccountsDataSetPostCode := TStringField.Create(Self);
  AccountsDataSetCountryCode := TStringField.Create(Self);
  AccountsDataSetExternalId := TStringField.Create(Self);
  AccountsDataSetTelephone := TStringField.Create(Self);
  AccountsDataSetEmail := TStringField.Create(Self);
  AccountsDataSetSchoolId := TIntegerField.Create(Self);
  tmrAccountsDataLoad := TTimer.Create(Self);

  DataTable.BeforeLoadDFMValues;
  MainDataset.BeforeLoadDFMValues;
  MainDatasetId.BeforeLoadDFMValues;
  MainDatasetDateAdded.BeforeLoadDFMValues;
  MainDatasetAddedBy.BeforeLoadDFMValues;
  MainDatasetLastUpdatedBy.BeforeLoadDFMValues;
  MainDatasetLastUpdated.BeforeLoadDFMValues;
  MainDatasetLocationName.BeforeLoadDFMValues;
  MainDatasetAdd1.BeforeLoadDFMValues;
  MainDatasetAdd2.BeforeLoadDFMValues;
  MainDatasetAdd3.BeforeLoadDFMValues;
  MainDatasetTown.BeforeLoadDFMValues;
  MainDatasetRegion.BeforeLoadDFMValues;
  MainDatasetPostCode.BeforeLoadDFMValues;
  MainDatasetCountryCode.BeforeLoadDFMValues;
  MainDatasetExternalId.BeforeLoadDFMValues;
  MainDatasetTelephone.BeforeLoadDFMValues;
  MainDatasetEmail.BeforeLoadDFMValues;
  MainDatasetLocalAuthority.BeforeLoadDFMValues;
  MainDatasetAcademyId.BeforeLoadDFMValues;
  MainDatasetStatus.BeforeLoadDFMValues;
  MainDatasetSchoolKind.BeforeLoadDFMValues;
  MainDatasetPupilCount.BeforeLoadDFMValues;
  MainDatasetCostingId.BeforeLoadDFMValues;
  MainDatasetPONumber.BeforeLoadDFMValues;
  WebElementActionList1.BeforeLoadDFMValues;
  AccountsDataSet.BeforeLoadDFMValues;
  AccountsDataSetId.BeforeLoadDFMValues;
  AccountsDataSetDateAdded.BeforeLoadDFMValues;
  AccountsDataSetAddedBy.BeforeLoadDFMValues;
  AccountsDataSetLastUpdatedBy.BeforeLoadDFMValues;
  AccountsDataSetLastUpdated.BeforeLoadDFMValues;
  AccountsDataSetLocationName.BeforeLoadDFMValues;
  AccountsDataSetAdd1.BeforeLoadDFMValues;
  AccountsDataSetAdd2.BeforeLoadDFMValues;
  AccountsDataSetAdd3.BeforeLoadDFMValues;
  AccountsDataSetTown.BeforeLoadDFMValues;
  AccountsDataSetRegion.BeforeLoadDFMValues;
  AccountsDataSetPostCode.BeforeLoadDFMValues;
  AccountsDataSetCountryCode.BeforeLoadDFMValues;
  AccountsDataSetExternalId.BeforeLoadDFMValues;
  AccountsDataSetTelephone.BeforeLoadDFMValues;
  AccountsDataSetEmail.BeforeLoadDFMValues;
  AccountsDataSetSchoolId.BeforeLoadDFMValues;
  tmrAccountsDataLoad.BeforeLoadDFMValues;
  try
    SetEvent(Self, 'OnShow', 'WebFormShow');
    DataTable.Columns.Clear;
    with DataTable.Columns.Add do
    begin
      DataField := 'Id';
      Title := 'Id';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'ExternalId';
      Title := 'School Id';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'LocationName';
      Title := 'Name';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'SchoolKind';
      Title := 'Type';
    end;
    with DataTable.Columns.Add do
    begin
      Title := 'Actions';
      Width := 300;
    end;
    MainDataset.EntitySetName := 'School';
    MainDatasetId.SetParentComponent(MainDataset);
    MainDatasetId.Name := 'MainDatasetId';
    MainDatasetId.FieldName := 'Id';
    MainDatasetDateAdded.SetParentComponent(MainDataset);
    MainDatasetDateAdded.Name := 'MainDatasetDateAdded';
    MainDatasetDateAdded.FieldName := 'DateAdded';
    MainDatasetAddedBy.SetParentComponent(MainDataset);
    MainDatasetAddedBy.Name := 'MainDatasetAddedBy';
    MainDatasetAddedBy.FieldName := 'AddedBy';
    MainDatasetLastUpdatedBy.SetParentComponent(MainDataset);
    MainDatasetLastUpdatedBy.Name := 'MainDatasetLastUpdatedBy';
    MainDatasetLastUpdatedBy.FieldName := 'LastUpdatedBy';
    MainDatasetLastUpdated.SetParentComponent(MainDataset);
    MainDatasetLastUpdated.Name := 'MainDatasetLastUpdated';
    MainDatasetLastUpdated.FieldName := 'LastUpdated';
    MainDatasetLocationName.SetParentComponent(MainDataset);
    MainDatasetLocationName.Name := 'MainDatasetLocationName';
    MainDatasetLocationName.FieldName := 'LocationName';
    MainDatasetLocationName.Size := 255;
    MainDatasetAdd1.SetParentComponent(MainDataset);
    MainDatasetAdd1.Name := 'MainDatasetAdd1';
    MainDatasetAdd1.FieldName := 'Add1';
    MainDatasetAdd1.Size := 75;
    MainDatasetAdd2.SetParentComponent(MainDataset);
    MainDatasetAdd2.Name := 'MainDatasetAdd2';
    MainDatasetAdd2.FieldName := 'Add2';
    MainDatasetAdd2.Size := 75;
    MainDatasetAdd3.SetParentComponent(MainDataset);
    MainDatasetAdd3.Name := 'MainDatasetAdd3';
    MainDatasetAdd3.FieldName := 'Add3';
    MainDatasetAdd3.Size := 75;
    MainDatasetTown.SetParentComponent(MainDataset);
    MainDatasetTown.Name := 'MainDatasetTown';
    MainDatasetTown.FieldName := 'Town';
    MainDatasetTown.Size := 75;
    MainDatasetRegion.SetParentComponent(MainDataset);
    MainDatasetRegion.Name := 'MainDatasetRegion';
    MainDatasetRegion.FieldName := 'Region';
    MainDatasetRegion.Size := 75;
    MainDatasetPostCode.SetParentComponent(MainDataset);
    MainDatasetPostCode.Name := 'MainDatasetPostCode';
    MainDatasetPostCode.FieldName := 'PostCode';
    MainDatasetPostCode.Size := 25;
    MainDatasetCountryCode.SetParentComponent(MainDataset);
    MainDatasetCountryCode.Name := 'MainDatasetCountryCode';
    MainDatasetCountryCode.FieldName := 'CountryCode';
    MainDatasetCountryCode.Size := 2;
    MainDatasetExternalId.SetParentComponent(MainDataset);
    MainDatasetExternalId.Name := 'MainDatasetExternalId';
    MainDatasetExternalId.FieldName := 'ExternalId';
    MainDatasetExternalId.Size := 75;
    MainDatasetTelephone.SetParentComponent(MainDataset);
    MainDatasetTelephone.Name := 'MainDatasetTelephone';
    MainDatasetTelephone.FieldName := 'Telephone';
    MainDatasetTelephone.Size := 25;
    MainDatasetEmail.SetParentComponent(MainDataset);
    MainDatasetEmail.Name := 'MainDatasetEmail';
    MainDatasetEmail.FieldName := 'Email';
    MainDatasetEmail.Size := 75;
    MainDatasetLocalAuthority.SetParentComponent(MainDataset);
    MainDatasetLocalAuthority.Name := 'MainDatasetLocalAuthority';
    MainDatasetLocalAuthority.FieldName := 'LocalAuthority';
    MainDatasetLocalAuthority.Size := 50;
    MainDatasetAcademyId.SetParentComponent(MainDataset);
    MainDatasetAcademyId.Name := 'MainDatasetAcademyId';
    MainDatasetAcademyId.FieldName := 'AcademyId';
    MainDatasetStatus.SetParentComponent(MainDataset);
    MainDatasetStatus.Name := 'MainDatasetStatus';
    MainDatasetStatus.FieldName := 'Status';
    MainDatasetStatus.Required := True;
    MainDatasetStatus.Size := 8;
    MainDatasetSchoolKind.SetParentComponent(MainDataset);
    MainDatasetSchoolKind.Name := 'MainDatasetSchoolKind';
    MainDatasetSchoolKind.FieldName := 'SchoolKind';
    MainDatasetSchoolKind.Required := True;
    MainDatasetSchoolKind.Size := 11;
    MainDatasetPupilCount.SetParentComponent(MainDataset);
    MainDatasetPupilCount.Name := 'MainDatasetPupilCount';
    MainDatasetPupilCount.FieldName := 'PupilCount';
    MainDatasetCostingId.SetParentComponent(MainDataset);
    MainDatasetCostingId.Name := 'MainDatasetCostingId';
    MainDatasetCostingId.FieldName := 'CostingId';
    MainDatasetPONumber.SetParentComponent(MainDataset);
    MainDatasetPONumber.Name := 'MainDatasetPONumber';
    MainDatasetPONumber.FieldName := 'PONumber';
    MainDatasetPONumber.Size := 255;
    WebElementActionList1.Actions.Clear;
    with WebElementActionList1.Actions.Add do
    begin
      Control := edSearch;
      Event := heKeypress;
      ID := 'SearchText';
      Name := 'TrapEnter';
      PreventDefault := False;
    end;
    AccountsDataSet.SetParentComponent(Self);
    AccountsDataSet.Name := 'AccountsDataSet';
    AccountsDataSet.AfterPost := AccountsDataSetAfterPost;
    AccountsDataSet.EntitySetName := 'SchoolAccounts';
    AccountsDataSet.Left := 80;
    AccountsDataSet.Top := 416;
    AccountsDataSetId.SetParentComponent(AccountsDataSet);
    AccountsDataSetId.Name := 'AccountsDataSetId';
    AccountsDataSetId.FieldName := 'Id';
    AccountsDataSetDateAdded.SetParentComponent(AccountsDataSet);
    AccountsDataSetDateAdded.Name := 'AccountsDataSetDateAdded';
    AccountsDataSetDateAdded.FieldName := 'DateAdded';
    AccountsDataSetAddedBy.SetParentComponent(AccountsDataSet);
    AccountsDataSetAddedBy.Name := 'AccountsDataSetAddedBy';
    AccountsDataSetAddedBy.FieldName := 'AddedBy';
    AccountsDataSetLastUpdatedBy.SetParentComponent(AccountsDataSet);
    AccountsDataSetLastUpdatedBy.Name := 'AccountsDataSetLastUpdatedBy';
    AccountsDataSetLastUpdatedBy.FieldName := 'LastUpdatedBy';
    AccountsDataSetLastUpdated.SetParentComponent(AccountsDataSet);
    AccountsDataSetLastUpdated.Name := 'AccountsDataSetLastUpdated';
    AccountsDataSetLastUpdated.FieldName := 'LastUpdated';
    AccountsDataSetLastUpdated.Visible := False;
    AccountsDataSetLocationName.SetParentComponent(AccountsDataSet);
    AccountsDataSetLocationName.Name := 'AccountsDataSetLocationName';
    AccountsDataSetLocationName.FieldName := 'LocationName';
    AccountsDataSetLocationName.Size := 255;
    AccountsDataSetAdd1.SetParentComponent(AccountsDataSet);
    AccountsDataSetAdd1.Name := 'AccountsDataSetAdd1';
    AccountsDataSetAdd1.FieldName := 'Add1';
    AccountsDataSetAdd1.Size := 75;
    AccountsDataSetAdd2.SetParentComponent(AccountsDataSet);
    AccountsDataSetAdd2.Name := 'AccountsDataSetAdd2';
    AccountsDataSetAdd2.FieldName := 'Add2';
    AccountsDataSetAdd2.Size := 75;
    AccountsDataSetAdd3.SetParentComponent(AccountsDataSet);
    AccountsDataSetAdd3.Name := 'AccountsDataSetAdd3';
    AccountsDataSetAdd3.FieldName := 'Add3';
    AccountsDataSetAdd3.Size := 75;
    AccountsDataSetTown.SetParentComponent(AccountsDataSet);
    AccountsDataSetTown.Name := 'AccountsDataSetTown';
    AccountsDataSetTown.FieldName := 'Town';
    AccountsDataSetTown.Size := 75;
    AccountsDataSetRegion.SetParentComponent(AccountsDataSet);
    AccountsDataSetRegion.Name := 'AccountsDataSetRegion';
    AccountsDataSetRegion.FieldName := 'Region';
    AccountsDataSetRegion.Size := 75;
    AccountsDataSetPostCode.SetParentComponent(AccountsDataSet);
    AccountsDataSetPostCode.Name := 'AccountsDataSetPostCode';
    AccountsDataSetPostCode.FieldName := 'PostCode';
    AccountsDataSetPostCode.Size := 25;
    AccountsDataSetCountryCode.SetParentComponent(AccountsDataSet);
    AccountsDataSetCountryCode.Name := 'AccountsDataSetCountryCode';
    AccountsDataSetCountryCode.FieldName := 'CountryCode';
    AccountsDataSetCountryCode.Size := 2;
    AccountsDataSetExternalId.SetParentComponent(AccountsDataSet);
    AccountsDataSetExternalId.Name := 'AccountsDataSetExternalId';
    AccountsDataSetExternalId.FieldName := 'ExternalId';
    AccountsDataSetExternalId.Size := 75;
    AccountsDataSetTelephone.SetParentComponent(AccountsDataSet);
    AccountsDataSetTelephone.Name := 'AccountsDataSetTelephone';
    AccountsDataSetTelephone.FieldName := 'Telephone';
    AccountsDataSetTelephone.Size := 25;
    AccountsDataSetEmail.SetParentComponent(AccountsDataSet);
    AccountsDataSetEmail.Name := 'AccountsDataSetEmail';
    AccountsDataSetEmail.FieldName := 'Email';
    AccountsDataSetEmail.Size := 75;
    AccountsDataSetSchoolId.SetParentComponent(AccountsDataSet);
    AccountsDataSetSchoolId.Name := 'AccountsDataSetSchoolId';
    AccountsDataSetSchoolId.FieldName := 'SchoolId';
    AccountsDataSetSchoolId.Required := True;
    tmrAccountsDataLoad.SetParentComponent(Self);
    tmrAccountsDataLoad.Name := 'tmrAccountsDataLoad';
    tmrAccountsDataLoad.Enabled := False;
    tmrAccountsDataLoad.Interval := 500;
    SetEvent(tmrAccountsDataLoad, Self, 'OnTimer', 'tmrAccountsDataLoadTimer');
    tmrAccountsDataLoad.Left := 192;
    tmrAccountsDataLoad.Top := 416;
  finally
    DataTable.AfterLoadDFMValues;
    MainDataset.AfterLoadDFMValues;
    MainDatasetId.AfterLoadDFMValues;
    MainDatasetDateAdded.AfterLoadDFMValues;
    MainDatasetAddedBy.AfterLoadDFMValues;
    MainDatasetLastUpdatedBy.AfterLoadDFMValues;
    MainDatasetLastUpdated.AfterLoadDFMValues;
    MainDatasetLocationName.AfterLoadDFMValues;
    MainDatasetAdd1.AfterLoadDFMValues;
    MainDatasetAdd2.AfterLoadDFMValues;
    MainDatasetAdd3.AfterLoadDFMValues;
    MainDatasetTown.AfterLoadDFMValues;
    MainDatasetRegion.AfterLoadDFMValues;
    MainDatasetPostCode.AfterLoadDFMValues;
    MainDatasetCountryCode.AfterLoadDFMValues;
    MainDatasetExternalId.AfterLoadDFMValues;
    MainDatasetTelephone.AfterLoadDFMValues;
    MainDatasetEmail.AfterLoadDFMValues;
    MainDatasetLocalAuthority.AfterLoadDFMValues;
    MainDatasetAcademyId.AfterLoadDFMValues;
    MainDatasetStatus.AfterLoadDFMValues;
    MainDatasetSchoolKind.AfterLoadDFMValues;
    MainDatasetPupilCount.AfterLoadDFMValues;
    MainDatasetCostingId.AfterLoadDFMValues;
    MainDatasetPONumber.AfterLoadDFMValues;
    WebElementActionList1.AfterLoadDFMValues;
    AccountsDataSet.AfterLoadDFMValues;
    AccountsDataSetId.AfterLoadDFMValues;
    AccountsDataSetDateAdded.AfterLoadDFMValues;
    AccountsDataSetAddedBy.AfterLoadDFMValues;
    AccountsDataSetLastUpdatedBy.AfterLoadDFMValues;
    AccountsDataSetLastUpdated.AfterLoadDFMValues;
    AccountsDataSetLocationName.AfterLoadDFMValues;
    AccountsDataSetAdd1.AfterLoadDFMValues;
    AccountsDataSetAdd2.AfterLoadDFMValues;
    AccountsDataSetAdd3.AfterLoadDFMValues;
    AccountsDataSetTown.AfterLoadDFMValues;
    AccountsDataSetRegion.AfterLoadDFMValues;
    AccountsDataSetPostCode.AfterLoadDFMValues;
    AccountsDataSetCountryCode.AfterLoadDFMValues;
    AccountsDataSetExternalId.AfterLoadDFMValues;
    AccountsDataSetTelephone.AfterLoadDFMValues;
    AccountsDataSetEmail.AfterLoadDFMValues;
    AccountsDataSetSchoolId.AfterLoadDFMValues;
    tmrAccountsDataLoad.AfterLoadDFMValues;
  end;
end;

end.
